export default __webpack_public_path__ + "static/media/add-to-playlist-purple.00cff5f8.svg";